module.exports = __webpack_public_path__ + "static/media/exchange-alt.2551c213.svg";